import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { DialogService } from './dialog.service';

export interface CanComponentDeactivate {
  canDeactivate: ( nextState?: RouterStateSnapshot ) => Observable<boolean> | boolean;
}
// https://github.com/angular/angular/issues/13586
@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(
    private dialogService: DialogService,
    private titleService: Title,
) {


}

  canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
    ): boolean | Observable<boolean> {
    if ( nextState.url.includes( 'error' ) ) {
        return true;
    }
      if ( this.dialogService.hasActiveDialog() || this.dialogService.isLoadingInProgress() ) {
    // if ( this.dialogService.isLoadingInProgress() ) {
      history.pushState({}, '', environment.production ? '/iq' + state.url : state.url );
      this.titleService.setTitle( route.data.title );
    } else {
      return component.canDeactivate ? component.canDeactivate( nextState ) : true;
    }
    return this.dialogService.allowDeactivation();
  }
}
